import { useCallback, useEffect, useState } from 'react';
import { Trash2 } from 'react-feather';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
  Col,
  Row,
  CardImg
} from 'reactstrap';
import FormSidebar from './Sidebar';
import api from '../../../graphql/api';

const PhraseDesign = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [images, setImages] = useState([]);

  const handleFetch = useCallback(async () => {
    const data = (await api.get('/phrase-design')).data;
    setImages(data);
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`/phrase-design/${id}`);
    handleFetch();
  };

  // ** Function to toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCreate = () => {
    toggleSidebar();
    handleFetch();
  };

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  return (
    <Card body>
      <CardHeader>
        <div>
          <CardTitle color="#6D6B7B">Carátulas para Frases</CardTitle>
          <CardSubtitle
            color="#6D6B7B"
            style={{
              marginTop: 10
            }}
          >
            Diseño de carátulas para frases
          </CardSubtitle>
        </div>
        <Button type="button" color="primary" onClick={handleCreate}>
          Subir Nuevo
        </Button>
      </CardHeader>
      <CardBody>
        <Row>
          {images.map((item) => (
            <Col key={item._id} md={3}>
              <Card>
                <img
                  className="rounded"
                  style={{
                    backgroundImage: `url(${item.uri})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                  }}
                  height={200}
                  width={200}
                />
                <span
                  className="position-absolute "
                  onClick={() => handleDelete(item._id)}
                  style={{
                    padding: 10,
                    backgroundColor: 'red',
                    borderRadius: 100,
                    top: 8,
                    right: 30,
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  <Trash2 size={20} color="white" fill="white" />
                </span>
              </Card>
            </Col>
          ))}
        </Row>
      </CardBody>
      <FormSidebar
        open={sidebarOpen}
        toggleSidebar={toggleSidebar}
        handleFetch={handleCreate}
      />
    </Card>
  );
};

export default PhraseDesign;
